import { mapState } from 'vuex';
import ApiService from '@/services/apiService';

export default {
  data() {
    return {
      accountFilterReady: false,
      selectedAccounts: [],

      searchItems: [],
      searchGroups: [],
      searchTags: [],
    };
  },
  computed: {
    ...mapState('app', ['language']),
    searchTypes() {
      return [
        {
          text: this.$t('Common.id'),
          param: 'logId',
        },
        {
          text: this.$t('AlarmLogs.search.message'),
          param: 'message',
        },
        {
          text: this.$t('AlarmLogs.search.deviceId'),
          param: 'virtualDeviceId',
        },
        {
          text: this.$t('AlarmLogs.search.logCategory'),
          param: 'logCategory',
          searchHandler: () => {
            return {
              totalCount: this.logCategories.length,
              items: this.logCategories,
            };
          },
        },
        {
          text: this.$t('AlarmLogs.search.severity'),
          param: 'severity',
          items: [
            {
              text: this.$t('AlarmLogs.severities.error'),
              value: 'error',
            },
            {
              text: this.$t('AlarmLogs.severities.warning'),
              value: 'warning',
            },
          ],
          combobox: true,
        },
        {
          text: this.$t('AlarmLogs.search.operationalStatus'),
          param: 'virtualDeviceOperationalStatus',
          searchHandler: () => {
            return {
              totalCount: this.operationalStatusItems.length,
              items: this.operationalStatusItems,
            };
          },
        },
        {
          text: this.$t('AlarmLogs.search.group'),
          param: 'virtualDeviceGroups',
          searchHandler: async (searchFor, page, pageSize) => {
            const result = await this.searchForGroups(searchFor, page, pageSize);
            return {
              totalCount: result.totalCount,
              items: result.groupList,
            };
          },
        },
        {
          text: this.$t('AlarmLogs.search.tag'),
          param: 'tags',
          searchHandler: async (searchFor, page, pageSize) => {
            const result = await this.searchForTags(searchFor, page, pageSize);
            return {
              totalCount: result.totalCount,
              items: result.tagList,
            };
          },
        },
        {
          text: this.$t('AlarmLogs.search.status'),
          param: 'isResolved',
          searchHandler: () => {
            return {
              totalCount: this.resolvedState.length,
              items: this.resolvedState,
            };
          },
        },
      ];
    },
    resolvedState() {
      return [
        { text: this.$t('AlarmLogs.search.resolved'), value: true },
        { text: this.$t('AlarmLogs.search.unresolved'), value: false },
      ];
    },
    operationalStatus() {
      return {
        0: this.$t('NiotaClassic.Devices.form.unset'),
        1: this.$t('NiotaClassic.Devices.form.inTransit'),
        2: this.$t('NiotaClassic.Devices.form.readyForOperation'),
        3: this.$t('NiotaClassic.Devices.form.inOperation'),
        4: this.$t('NiotaClassic.Devices.form.temporaryInactive'),
        5: this.$t('NiotaClassic.Devices.form.decommissioned'),
      };
    },
    operationalStatusItems() {
      return Object.keys(this.operationalStatus).map((status) => {
        return { text: this.operationalStatus[status], value: status };
      });
    },
    logCategories() {
      return [
        { text: this.$t('AlarmLogs.categories.connectivity'), value: 'connectivity' },
        { text: this.$t('AlarmLogs.categories.battery'), value: 'battery' },
        { text: this.$t('AlarmLogs.categories.device'), value: 'device' },
        { text: this.$t('AlarmLogs.categories.packet-threshold'), value: 'packet-threshold' },
        {
          text: this.$t('AlarmLogs.categories.connector-monitoring'),
          value: 'connector-monitoring',
        },
      ];
    },
  },
  watch: {
    language() {
      (this.searchTypes.find((item) => item.param === 'virtualDeviceOperationalStatus') || {}).items =
        this.operationalStatusItems;
      (this.searchTypes.find((item) => item.param === 'logCategory') || {}).items = this.logCategories;
      (this.searchTypes.find((item) => item.param === 'virtualDeviceGroups') || {}).items = this.searchGroups;
      (this.searchTypes.find((item) => item.param === 'tags') || {}).items = this.searchTags;
      (this.searchTypes.find((item) => item.param === 'isResolved') || {}).items = this.resolvedState;
    },
  },
  methods: {
    async searchForGroups() {
      const result = await ApiService.virtualDeviceFetchGroups(this, null);
      result.groupList = result.groupList.map((group) => {
        return { value: group, text: group };
      });

      return result;
    },
    async searchForTags() {
      const result = await ApiService.virtualDeviceFetchTags();
      result.tagList = result.tagList.map((tag) => {
        return { value: tag, text: tag };
      });

      return result;
    },
  },
};
